import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { termDataListDetailsProps } from "../TermDataReducer/TermDataSlice";

export interface employeeRewards {
  userId: string;
  employeeId: string;
  firstName: string;
  lastName: string;
  email: string;
  totalPoints: number;
  selectedReward: string | null;
  rewardAmount: number;
}

interface rewardStateProps {
  eligibleForRewardsTab: string;
  termCodeValue: string;
  employee_rewards_data: employeeRewards[];
  employeeRewardsLoading: boolean;
  activeReward: termDataListDetailsProps | null;
}

let initialState: rewardStateProps = {
  eligibleForRewardsTab: "eligible",
  termCodeValue: "",
  employee_rewards_data: [],
  employeeRewardsLoading: false,
  activeReward: null,
};

const RewardSliceReducer = createSlice({
  name: "Reward",
  initialState,
  reducers: {
    setEligibleForRewardsTab(state, action: PayloadAction<string>) {
      state.eligibleForRewardsTab = action.payload;
    },
    setTermCodeValue(state, action: PayloadAction<string>) {
      state.termCodeValue = action.payload;
    },
    setEmployeeRewardData(state, action: PayloadAction<employeeRewards[]>) {
      state.employee_rewards_data = action.payload;
    },
    setEmployeeRewardsLoading(state, action: PayloadAction<boolean>) {
      state.employeeRewardsLoading = action.payload;
    },
    setActiveReward(
      state,
      action: PayloadAction<termDataListDetailsProps | null>,
    ) {
      state.activeReward = action.payload;
    },
  },
});

export const {
  setTermCodeValue,
  setEligibleForRewardsTab,
  setEmployeeRewardData,
  setEmployeeRewardsLoading,
  setActiveReward,
} = RewardSliceReducer.actions;

export default RewardSliceReducer.reducer;
